import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const config = {
  apiKey: 'AIzaSyC8hpwSLrC9yo7DL8leRAa648da1TPXa6w',
  authDomain: 'alpha-me-3eff3.firebaseapp.com',
  projectId: 'alpha-me-3eff3',
  storageBucket: 'alpha-me-3eff3.appspot.com',
  messagingSenderId: '1030168433980',
  appId: '1:1030168433980:web:bbf71289c13b022e09fa39',
};

export const firebase = Firebase.initializeApp(config);
export const storage = Firebase.storage();
export const googleAuthProvider = new Firebase.auth.GoogleAuthProvider();
export const emailAuthProvider = Firebase.auth.EmailAuthProvider;
export const timestamp = Firebase.firestore.Timestamp;

firebase.firestore().settings({
  cacheSizeBytes: Firebase.firestore.CACHE_SIZE_UNLIMITED,
});

firebase
  .firestore()
  .enablePersistence()
  .catch((err) => {
    console.log(err);
  });
